export default __webpack_public_path__ + "static/testimonials-bg-tr-aca4b08f1d3d1eb56c8ea7efbe5fb41a.svg";